import { Routes, Route } from "react-router-dom";
import './App.css'
import { LanguageProvider } from './LanguageContext'
import { AuthProvider } from './AuthContext'
import Login from './login/page';
import Dashboard from './dashboard/page';
import Products from './products/page';
import Variants from './variants/page';
import Invoices from './invoices/page';
import InvoiceDetail from './invoices/detail';
import Clients from './clients/page';
import Charges from './charges/page';
import ActivityLogs from './activity-logs/page';
import Users from './users/page';
import Roles from './roles/page';

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/products' element={<Products />} />
          <Route path='/variants' element={<Variants />} />
          <Route path='/invoices' element={<Invoices />} />
          <Route path='/invoices/:id' element={<InvoiceDetail />} />
          <Route path='/clients' element={<Clients />} />
          <Route path='/charges' element={<Charges />} />
          <Route path='/activity-logs' element={<ActivityLogs />} />
          <Route path='/users' element={<Users />} />
          <Route path='/roles' element={<Roles />} />
          <Route path='*' element={<div className="flex justify-center min-h-screen items-center">NOT FOUND</div>} />
        </Routes>
      </AuthProvider>
    </LanguageProvider>
  )
}
